import { ContentApi } from "@/api/content";
import { GetServerSideProps } from "next";

export const getServerSideProps: GetServerSideProps = async ({ preview = false }) => {
  let faqList: PostPublicFaqListDto[] = [];
  try {
    await ContentApi.getFaqs().then((res) => {
      faqList = res.data;
    });
  } catch (ex) {}

  return { props: { faqs: faqList } };
};

type Props = {
  faqs: PostPublicFaqListDto[];
};

export default function FaqHome({ faqs }: Props) {
  return (
    <>
      <div className="rbt-section-gap">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="section-title text-center">
                <h2 className="title">FAQ</h2>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="rbt-accordion-area accordion-style-1 bg-color-white">
        <div className="container">
          <div className="row g-5">
            <div className="col-lg-12">
              <div className="rbt-accordion-style accordion">
                <div className="rbt-accordion-style rbt-accordion-04 accordion">
                  <div className="accordion" id="accordionExamplec3">
                    {/* {faqs.map((item, index) => (
                      <div className="accordion-item card" key={index}>
                        <h2 className="accordion-header card-header" id={item.id}>
                          <button
                            className={`accordion-button collapsed`}
                            type="button"
                            data-bs-toggle="collapse"
                            data-bs-target={`#div-${index}`}
                            aria-expanded={false}
                            aria-controls={`#div-${index}`}
                          >
                            {item.title}
                          </button>
                        </h2>
                        <div id={`div-${index}`} className={`accordion-collapse collapse`} aria-labelledby={item.title} data-bs-parent="#accordionExamplec3">
                          <div className="accordion-body card-body" dangerouslySetInnerHTML={{ __html: item.text }} />
                        </div>
                      </div>
                    ))} */}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

